module.exports = __webpack_public_path__ + "img/icon-flood-zone.33d8ce49.svg";